import React from 'react';
import { Button, ButtonProps, useMediaQuery, useTheme } from '@mui/material';

const ResponsiveButton: React.FC<ButtonProps> = ({ startIcon, children, sx, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Button
      tabIndex={2}
      {...props}
      startIcon={isMobile ? startIcon : undefined}
      sx={{
        minWidth: isMobile ? 40 : 'auto',
        padding: isMobile ? '6px 6px 6px 16px' : '6px 16px',
        position: 'relative',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {!isMobile && children}
    </Button>
  );
};

export default ResponsiveButton;
